import { defineNuxtRouteMiddleware, navigateTo } from '#imports'

import { useIsWebview } from '@backmarket/nuxt-module-navigation/useIsWebview'

import { toWebviewRouteName } from '../utils'

/* eslint-disable consistent-return */
export default defineNuxtRouteMiddleware((to, from) => {
  if (!to.name?.toString()) return
  if (to.meta?.isWebview) return

  const isWebview = useIsWebview()

  // Redirect links within the webview version to their webview version
  if (!to.meta?.isWebview && from.meta?.isWebview) {
    return navigateTo({
      name: toWebviewRouteName(String(to.name)),
      params: to.params,
      query: to.query,
    })
  }

  // Redirect to the webview version when the user agent is webview-specific
  if (isWebview) {
    return navigateTo({
      name: toWebviewRouteName(String(to.name)),
      params: to.params,
      query: to.query,
    })
  }
})
